export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_19.3f32b8b0.jpg";